import { enumToArrayString } from "@theatticusapp/atticus-shared-components";
import { AtticusScreenFlow } from "../../models/AtticusScreenFlow";
import * as NoticeToCreditorsFlow from "./NoticeToCreditors/flow";
import * as OnBoardingFlow from "./OnBoarding/flow";
import * as FinancialConversationFlow from "./FinancialConversation/flow";
import * as PrimaryHomeFlow from "./PrimaryHome/flow";

const DISABLED = true;

export const onBoardingFlow = new AtticusScreenFlow(
  OnBoardingFlow.screenFlow,
  "on-boarding",
  enumToArrayString(OnBoardingFlow.Sections),
  enumToArrayString(OnBoardingFlow.Screens)
);

export const noticeToCreditorsFlow = new AtticusScreenFlow(
  NoticeToCreditorsFlow.screenFlow,
  "notice-to-creditors",
  enumToArrayString(NoticeToCreditorsFlow.Sections),
  enumToArrayString(NoticeToCreditorsFlow.Screens),
  DISABLED
);

export const financialConvoFlow = new AtticusScreenFlow(
  FinancialConversationFlow.screenFlow,
  "financial-convo",
  enumToArrayString(FinancialConversationFlow.Sections),
  enumToArrayString(FinancialConversationFlow.Screens)
);

export const primaryHomeFlow = new AtticusScreenFlow(
  PrimaryHomeFlow.screenFlow,
  "primary-home",
  enumToArrayString(PrimaryHomeFlow.Sections),
  enumToArrayString(PrimaryHomeFlow.Screens)
);
